import { render, staticRenderFns } from "./orderPositions.vue?vue&type=template&id=093c179a&scoped=true&"
import script from "./orderPositions.vue?vue&type=script&lang=js&"
export * from "./orderPositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093c179a",
  null
  
)

export default component.exports